<template>
    <div class="top-nav" v-if="!hideNavbar()">
        <div @click="() => router.push('/')" class="top-nav__logo">
            <img src="@\assets\logo-forge.png" alt="">
            <h3>{{logoText}}</h3>
        </div>
        <div class="top-nav__menu" v-if="!route.query.t === 'OD' || logged">
            <router-link to="/" :class="{'active': route.name == 'HOME'}"><span>{{$t('nav.HOME')}}</span></router-link> 
            <router-link v-if="user.permissions.includes('CURSO_VER_PROPIOS')" to="/my-courses" :class="{'active': route.name && route.name.includes('COURSE') && !route.path.includes('management') && !route.path.includes('contents') }"><span>{{$t('nav.COURSES')}}</span></router-link>
            <template v-if="!(user.role?.toLowerCase() === 'learninguser' && user.type?.toLowerCase() === 'joven')">
                <router-link v-if="user.permissions.includes('RECURSO_VISUALIZACION')" to="/resources" :class="{'active': route.name == 'RESOURCES'}"><span>{{$t('nav.RESOURCES')}}</span></router-link> 
            </template>
        </div>
        <div class="top-nav__user">
            <!-- <div class="container-search">
                <input type="text" placeholder="Buscar">
                <i class="material-icons">search</i>
            </div>
            <div class="pipe"></div> -->
            <i :title="$t('nav.HELP')" v-if="!route.query.t === 'OD' || logged" class="material-icons" @click.stop="openHelpMenu()">help</i>
            <i :title="$t('nav.NOTIFICATIONS')" v-if="!route.query.t === 'OD' || logged" class="material-icons">notifications</i>
            <div :title="$t('nav.PROFILE2')" v-if="!route.query.t === 'OD' || logged" class="container-user" @click="openUserMenu()">
                <img v-if="user.picture" :src="getFile(user.picture,'user')">
                <img v-else src="@\assets\user.png" alt="">
            </div>
        </div>
    </div>
    
</template>

<script>
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { computed, inject, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

export default {
    setup(_, {emit}) {
        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const locationsWhenHideNavbar = ['/preinscription/', '/contentshare']
        const getFile = inject("getFile");
        const user = computed(() => store.getters.manageUser_user);
        // const logoText = ref('Experiencias educativas');
        const logoText = ref('');
        const { t } = useI18n();

        const logged = computed(() => store.getters.manageUser_logged);


        function openUserMenu() {
            emit('openUserMenu');
        }

        function openHelpMenu(){
            emit('openHelpMenu');
        }

        const hideNavbar = () => locationsWhenHideNavbar.filter(location => route.path.toLowerCase().includes(location))?.length

        onMounted(()=>{
            // if(location.href.includes('changeColors') || location.href.includes('learning.fundacionforge.org')){
            //     logoText.value = 'Learning Community';
            // }
            if(location.href.includes('changeColors') || location.href.includes('learning.fundacionforge.org')){
                logoText.value = t('nav.EDUCATIVE_EXPERIENCES_EN');
            } else {
                logoText.value = t('nav.EDUCATIVE_EXPERIENCES');
            }
        })

        return {
            openUserMenu,
            openHelpMenu,
            route,
            getFile,
            user,
            router,
            logoText,
            hideNavbar,
            logged
        }

    }
    
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';
.top-nav{
    height: 56px;
    position: sticky;
    top: 0;
    z-index: 2000;
    padding: 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    color: #7d7d7d;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);

    &__logo{
        display: flex;
        align-items: flex-end;
        color: #7d7d7d;
        gap: 8px;
        cursor: pointer;
        img{
            width: 46px;
            
        }
        h3{
            //font-size: 21px;
            padding-bottom: 2px;
            color: $black;
        }
    }
    &__menu{
        display: flex;
        width: fit-content;
        gap: 32px;
        a{
            display: inline-flex;
            align-items: center;
            gap: 4px;
            color: $black;
            text-decoration: none;
            &:last-child{
                gap: 1px;
            }
            &:hover, &.active{
                color: $green;
            }
            span{
                font-style: normal;
                font-weight: 600;
                font-size: 14px;
            }
        }
    }

    &__user{
        width: fit-content;
        padding-right: 8px;
        display: flex;
        align-items: center;
        gap: 30px;

        .material-icons {
            color: $black;
            cursor: pointer;
            &:nth-child(2){
                cursor: default;
            }
        }

        .container-search {
            position: relative;
            width: 100%;
            display: flex;
            align-items: center;
            
            i {
                position: absolute;
                right: 0;
                padding-right: 12px;
                font-size: 24px;
                cursor: pointer;
                color: #7d7d7d;
            }

            input {
                background: #f6f6f6;
                border: none;
                padding: 8px 12px;
                max-width: 300px;
                width: 100%;
                border-radius: 12px;
                color: #7d7d7d;
            
                &::placeholder {
                    color: #7d7d7d;
                }
            }

        }

        .pipe {
            border: 1px solid #e0e0e0;
            border-radius: 12px;
            margin: 0 24px;
            height: 32px;
        }

        .container-user {
            position: relative;
            width: 38px;
            height: 38px;
            flex-shrink: 0;
            border-radius: 100%;
            overflow: hidden;
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
                cursor: pointer;
            }
        }
    }
}

</style>